type PlanOrientation = 'PORTRAIT' | 'LANDSCAPE';
export default PlanOrientation;

export const PlanOrientations: PlanOrientation[] = ['PORTRAIT', 'LANDSCAPE'];